var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"avatar-interface"}},[_c('div',{staticClass:"ai-decoration",style:(_vm.style)},[_c('img',{attrs:{"src":_vm.avatarDriver,"alt":_vm.alt}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }